import { render, staticRenderFns } from "./CommentsTimeline.vue?vue&type=template&id=06b5dfc5&scoped=true&"
import script from "./CommentsTimeline.vue?vue&type=script&lang=js&"
export * from "./CommentsTimeline.vue?vue&type=script&lang=js&"
import style0 from "./CommentsTimeline.vue?vue&type=style&index=0&id=06b5dfc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5dfc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VList,VSheet})
